import themeReducer from '@app/store/slices/themeSlice';
import pwaReducer from '@app/store/slices/pwaSlice';
import dataReducer from '@app/store/slices/dataSlice';

export default {
  theme: themeReducer,
  pwa: pwaReducer,
  data: dataReducer,
};
